export const dashboardKeys = {
  all: ['dashboard'] as const,
  data: (userId: string) => [...dashboardKeys.all, 'data', userId] as const,
  dailyPlan: (caseId: number) =>
    [...dashboardKeys.all, 'dailyPlan', caseId] as const,
};
